import React from 'react';
import PropTypes from 'prop-types';

const SDArticle = ({ headline, description, image, datePublished, dateModified, url, author, authorUrl }) => {
	// remove paragraph tag, convert double quotes to single, convert line breaks to a single space
	const fixedDescription = description
		?.replace(/<\/?p[^>]*>/g, '')
		.replace(/"/g, "'")
		.replace(/(\r\n|\n|\r)/gm, ' ');
	const published = datePublished ? new Date(datePublished) : '';
	const modified = dateModified ? new Date(dateModified) : '';

	return (
		<script
			type='application/ld+json'
			dangerouslySetInnerHTML={{
				__html: `{
				"@context": "https://schema.org",
				"@type": "Article",
				"headline": "${headline}",
				"description": "${fixedDescription}",
				"image": [
					"${image}"
				],
				"datePublished": "${published ? published.toISOString() : ''}",
				"dateModified": "${modified ? modified.toISOString() : ''}",
				"mainEntityOfPage": {
					"@type": "WebPage",
					"@id": "${url}"
				},
				"author": {
					"@type": "Person",
					"name": "${author}"${
						authorUrl
							? `,
					"url": "${authorUrl}"`
							: ''
					}
				},
				"publisher": {
					"@type": "Organization",
					"name": "Pella Windows and Doors",
					"logo": {
						"@type": "ImageObject",
						"url": "https://images.contentstack.io/v3/assets/bltf589e66bcaecd79c/blta3261a1e0aec11a9/5e971d3049d4fa359510191e/pella-logo-black-spot.png"
					}
				}
			}`,
			}}
		/>
	);
};

SDArticle.propTypes = {
	headline: PropTypes.string,
	description: PropTypes.string,
	image: PropTypes.string,
	datePublished: PropTypes.string,
	dateModified: PropTypes.string,
	url: PropTypes.string,
	author: PropTypes.string,
	authorUrl: PropTypes.string,
};

export default SDArticle;
